import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/DSV_Logo.svg";

const Footer = () => {
  const year = new Date().getFullYear();

  const company = [
    { to: "/aboutus", label: "About Us" },
    { to: "/services", label: "Services" },
    { to: "/portfolio", label: "Portfolio" },
    { to: "/contact", label: "Contact Us" },
  ];

  return (
    <footer className="bg-ink border-t border-ink-line">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src={logo} alt="" className="h-8 w-auto" />
              <span className="font-display text-[19px] tracking-[0.22em] text-paper leading-none pt-1">
                DEEP-C VISION
              </span>
            </div>
            <p className="text-sm text-muted max-w-xs leading-relaxed">
              A UK product studio designing and building AI-powered mobile
              products for creative arts, science and healthcare.
            </p>
          </div>

          <div>
            <h3 className="eyebrow mb-5">Company</h3>
            <ul className="space-y-3 text-sm">
              {company.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-muted hover:text-paper transition-colors py-1 inline-block focus-visible:ring-2 focus-visible:ring-brand-cyan rounded"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="eyebrow mb-5">Get in touch</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:contact@deepcvision.co.uk"
                  className="text-muted hover:text-paper transition-colors break-all"
                >
                  contact@deepcvision.co.uk
                </a>
              </li>
              <li>
                <a
                  href="tel:+447549348927"
                  className="text-muted hover:text-paper transition-colors whitespace-nowrap"
                >
                  +44 (0) 7549 348 927
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@Deep-cVisionLTD"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted hover:text-paper transition-colors"
                >
                  YouTube
                </a>
              </li>
              <li>
                <a
                  href="https://understated.me/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted hover:text-paper transition-colors"
                >
                  Understated{" "}
                  <span className="text-muted/60">· design partner</span>
                </a>
              </li>
              <li className="text-muted/70 leading-relaxed pt-1">
                54 Avondale Road,
                <br />
                Bromley, BR1 4EP, UK
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-ink-line flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[11px] tracking-wider text-muted/70">
            © {year} DEEP-C VISION LIMITED · REGISTERED IN THE UK
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              className="font-mono text-[11px] tracking-wider text-muted/70 hover:text-brand-cyan transition-colors"
            >
              PRIVACY
            </Link>
            <Link
              to="/cookie-policy"
              className="font-mono text-[11px] tracking-wider text-muted/70 hover:text-brand-cyan transition-colors"
            >
              COOKIES
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
